import React from 'react';

const Loading = () => {
    return (
      <div class='radial-progress'>
      </div>
    );
};

export default Loading;